import { useEffect, useState } from "react";
import { AppLanguage, getStoredLanguage, onLanguageChange } from "lib/language";

export function useAppLanguage(): AppLanguage {
  const [language, setLanguage] = useState<AppLanguage>(getStoredLanguage());

  useEffect(() => {
    setLanguage(getStoredLanguage());
    return onLanguageChange(setLanguage);
  }, []);

  return language;
}

